import { useCallback, useMemo } from 'react'
import { useLaneFiltersContext } from 'apps/fleet-planner/context/LaneFiltersContext'
import { useTrackConversionContext } from 'apps/fleet-planner/context/track-conversion-source'
import { hasBookableShipmentSavedSearch } from 'apps/fleet-planner/utils/bookableShipmentSavedSearch'
import { useSavedLanesContext } from '../context'

const DAT_SHIPMENT_KEY = '-d'
const TRUCKSTOP_SHIPMENT_KEY = '-t'

export const useTrackConversion = () => {
  const {
    clearTrackConversionData,
    setTrackConversion,
    sourceChannel,
    sourceSegment,
    utmSource,
  } = useTrackConversionContext()

  const { hasStartedSearch, params } = useLaneFiltersContext()
  const { filters: laneFilters } = params || {}
  const { savedLanes: savedSearches = [] } = useSavedLanesContext()
  const isSearchAlertActive = useMemo(
    () => laneFilters && hasBookableShipmentSavedSearch(laneFilters, savedSearches),
    [laneFilters, savedSearches]
  )

  const isDatShipmentId = (id: string = '') => id.includes(DAT_SHIPMENT_KEY)
  const isTruckstopShipmentId = (id: string = '') => id.includes(TRUCKSTOP_SHIPMENT_KEY)

  const applyRulesAndSetConversion = useCallback(() => {
    if (
      hasStartedSearch &&
      sourceChannel !== 'email' &&
      sourceSegment !== 'reloads_shipment_search'
    ) {
      if (isSearchAlertActive) {
        if (
          sourceSegment !== 'lane_alert_cm_created' &&
          sourceSegment !== 'lane_alert_auto_historical' &&
          sourceSegment !== 'lane_alert_carrier_truck_availability'
        ) {
          setTrackConversion('web', 'lane_alert_dispatcher_created')
        }
      } else {
        setTrackConversion('web', 'organic_shipment_search')
      }
    }
  }, [hasStartedSearch, isSearchAlertActive, sourceChannel, sourceSegment, setTrackConversion])

  return {
    sourceChannel,
    sourceSegment,
    setTrackConversion,
    clearTrackConversionData,
    applyRulesAndSetConversion,
    isDatShipmentId,
    isTruckstopShipmentId,
    utmSource,
  }
}
